import { Route, Routes } from 'react-router-dom';
import LoginPage from './login'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import {UserContextProvider} from './store/UserContextProvider';
import { AuthContextProvider } from './store/AuthContextProvider';
import React from 'react';
import  TokenExpirationHandler  from './pages/tokenexpiration/TokenExpirationHandler';
import Routers from './routers/router';
import SignOutOverlay from './api/sign-out-overlay';
import { AUTH_PROVIDER } from './authProvider';
import KeycloakGate from './store/KeycloakAuthContext';

const App= () => {

  const authenticatedTree = (
    <AuthContextProvider>
      <UserContextProvider>
        <Routers />
      </UserContextProvider>
    </AuthContextProvider>
  )

  return (
    <>
     <TokenExpirationHandler/>
     <SignOutOverlay/>
    {AUTH_PROVIDER === 'keycloak' ? (
      <KeycloakGate>{authenticatedTree}</KeycloakGate>
    ) : (
      <>
        <AuthenticatedTemplate>{authenticatedTree}</AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <LoginPage />
        </UnauthenticatedTemplate>
      </>
    )}
    </>
  )
};

export default App;
